export type RunMode = 'new' | 'resume';
export type CatalogMode = 'match_existing' | 'generate_fresh';
export type StartStage = 'simplification' | 'clustering' | 'catalog_merge' | 'post_processing';
export type PartIdAsSolutionName = 'off' | 'duplicate' | 'replace';

export type SlotKey =
    | 'historical_cases'
    | 'error_codes'
    | 'solution_codes_filename'
    | 'observation_catalog'
    | 'solutions_catalog'
    | 'part_info'
    | 'diagnostic_component';

// 'disabled' renders a greyed, unusable card; 'hidden' is not rendered at all.
export type SlotState = 'required' | 'optional' | 'disabled' | 'hidden';

export const RELEVANT_TO_OPTIONS = ['observations', 'solutions', 'diagnostics'] as const;

export type ColumnDefinition = {
    columns: string[];      // multi-select from uploaded historical-cases column names
    definition: string;
    relevantTo: string[];   // subset of RELEVANT_TO_OPTIONS values
};

export type FormState = {
    tenantId: string | null;
    runMode: RunMode | null;
    previousRun: string | null;
    startStage: StartStage | null;
    extractObservations: boolean;
    extractSolutions: boolean;
    extractDiagnostics: boolean;
    catalogMode: CatalogMode | null;
    productType: string;
    useCustomInstructions: boolean;
    useSolutionCodeNonSemanticClustering: boolean;
    ruleBasedObsLabelMerge: boolean;
    useExactMatchErrorCodeClustering: boolean;
    useExactMatchSolutionCodeClustering: boolean;
    clusterDiagnosticsByComponents: boolean;
    solutionCodeNonSemanticClusteringRules: string;
    useCustomPostProcessing: boolean;
    customPostProcessingRules: string;
    partIdAsSolutionName: PartIdAsSolutionName;
    maxCasesEnabled: boolean;
    maxCases: number;
    columnDefinitions: ColumnDefinition[];
    files: Record<SlotKey, File | null>;
    // Column headers parsed from each uploaded file, keyed by slot.
    fileColumns: Partial<Record<SlotKey, string[]>>;
};
